// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__35oTq","left":"InfoRow_left__1PuBE"};